export default __webpack_public_path__ + "static/media/Numbers_04.2774111c.png";